const en = {
  header: {
    selectLanguage: "Select language",
    languages: "Languages",
  },
  hero: {
    tagline: "GODO DEMO TRADING COMPETITION",
    title: "Showcase Your Trading Skills, Win Real Rewards!",
    subtitle:
      "Join the GODO Demo Trading Competition, trade with a {balance} demo initial balance, outshine other traders, and claim your share of the prize pool!",
    participateNow: "Participate Now",
    seeHowItWorks: "See How It Works",
    trophiesAlt: "Competition trophies",
  },
  countdown: {
    competitionStart: "Competition Starts In",
    startedAt: "{date}",
    competitionEnds: "Competition Ends In",
    endsAt: "{date}",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
  },
  prizes: {
    title: "Prizes",
    subtitle:
      "Top verified accounts share the full {prizePool} USD pool at competition close.",
    totalPrizePool: "Total Prize Pool",
    firstPlace: "1st Place",
    secondPlace: "2nd Place",
    thirdPlace: "3rd Place",
    fourthPlace: "4th Place",
    fifthPlace: "5th Place",
    fivthPlace: "5th Place",
    sixthPlace: "6th Place",
    seventhPlace: "7th Place",
    duration: "Duration",
    durationDay: "1 Day",
    durationDays: "{count} Days",
    durationWeek: "1 Week",
    durationWeeks: "{count} Weeks",
    durationMonth: "1 Month",
    durationMonths: "{count} Months",
    startingBalance: "Starting Balance",
    entry: "Entry",
    entryValue: "Free",
    accounts: "Accounts",
    accountsValue: "1 per Trader",
  },
  leaderboard: {
    title: "Leaderboard",
    rank: "Rank",
    trader: "Trader",
    equity: "Equity",
    profitLoss: "Profit / Loss",
    margin: "Performance %",
    drawdown: "Drawdown %",
    status: "Status",
    reason: "Reason",
    statusActive: "Active",
    statusPending: "Pending",
    statusDisqualified: "Disqualified",
    reasonNone: "—",
    reasonDrawdown: "Max drawdown ≥ 30% from peak",
    reasonLeftGroup: "Left the competition group",
    rankUp: "Rank up",
    rankDown: "Rank down",
    previous: "Previous",
    next: "Next",
    previousPage: "Previous page",
    pagination: "Leaderboard pages",
    nextPage: "Next page",
    mt5Login: "MT5 {login}",
    loading: "Loading live rankings…",
    empty: "No competition accounts yet. Rankings appear when MT5 demo accounts join the contest group.",
    loadError: "Unable to load the live leaderboard. Please try again shortly.",
    winnersTitle: "Winners",
    winnersSubtitle: "Final prize places on the stage — locked at competition close.",
    verified: "Verified",
    amount: "Amount",
    topTradersTitle: "Top Traders",
    topTradersSubtitle: "Current prize-eligible leaders on the stage.",
  },
  steps: {
    title: "Four Steps to Start",
    nextStep: "Next step",
    items: [
      {
        title: "Register & Verify",
        description:
          "Open your account quickly and securely. Our streamlined verification process gets you trading-ready in minutes, not days.",
      },
      {
        title: "Get Funded",
        description:
          "Deposit via your preferred method and instantly access your full trading environment with all instruments unlocked.",
      },
      {
        title: "Trade the Month",
        description:
          "Execute with precision using competitive ECN pricing and ultra-fast execution across MT4, MT5 and the GODO Mobile App.",
      },
      {
        title: "Win & Withdraw",
        description:
          "Climb the leaderboard, claim your share of the prize pool, and withdraw your rewards with ease.",
      },
    ],
  },
  rules: {
    title: "Official Competition Rules",
    items: [
      {
        title: "Eligibility & Registration",
        description:
          "Free to join, Complete KYC, One account per participant and one IP address.",
      },
      {
        title: "Trading Parameters",
        description:
          "All trades must be on the assigned {balance} demo account during the event.",
      },
      {
        title: "Ranking & Evaluation",
        description:
          "Ranked by highest ending equity. Ties are broken by lower Maximum Drawdown %.",
      },
      {
        title: "Disqualification",
        description:
          "Multiple accounts, Unfair practices, system abuse or rule violations will lead to disqualification.",
      },
      {
        title: "Prize Distribution",
        description:
          "Prizes for top 3 verified accounts with completed KYC. Non-transferable.",
      },
      {
        title: "General Provisions",
        description:
          "GODO reserves the right to amend, extend, postpone or cancel the competition at any time.",
      },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    close: "Close terms and conditions",
    loading: "Loading document…",
    unavailable: "Terms document is not available for this competition.",
  },
  bottomCta: {
    title: "Ready to Prove Your Edge?",
    text: "Free entry, virtual capital, real rewards. Complete KYC on the GODO portal and secure your competition account.",
  },
  footer: {
    qrAlt: "QR code",
    showQr: "Show app QR code",
    playStore: "Get it on Google Play",
    appStore: "Download on the App Store",
    social: "Social links",
    scanQr: "Scan to download the GODO app",
    copyright: "Copyright © 2026 – All Rights Reserved",
    regulationLabel: "Regulation and Authorization:",
    regulationBody:
      "“GODO LTD” (FSC License No GB20025812) is an authorized and registered limited company under the laws of Mauritius. We ensure that your account will be managed in full compliance with the rules and regulations set forth by the Financial Service Commission (FSC). The domain godocm.com is operated by GODO LTD.",
    introductionLabel: "GODO Introduction Financial Services LLC:",
    introductionBody:
      "(SCA License no: 20200000168) is an authorized and registered limited liability company under the law of the Securities Commodities Authorities (SCA), United Arab Emirates, under its exclusive partnership with GODO Limited (Mauritius) to exclusively facilitate our UAE Nationals and Residents. However, GODO Introduction is not authorized to hold clients' assets or money and all services are provided only on introduction basis.",
  },
  toast: {
    success: "Success notification",
    info: "Informational notification",
    warning: "Warning notification",
    error: "Error notification",
    dismiss: "Dismiss notification",
    reviewFields: "Please check the highlighted fields and try again.",
    registerSuccess: "Thank you. Your registration has been received.",
    submitError:
      "We could not complete your registration. Please try again. If the problem continues, contact support.",
    alreadyClient:
      "This email or phone number is already registered as a client. Please sign in as an existing user.",
    alreadyExists:
      "An account with this email or phone already exists. Use Existing User to check your eligibility.",
    documentsRequired:
      "Please upload proof of identity (front and back) and proof of address before submitting.",
    kycCheckError: "We could not check your KYC status. Please try again.",
    accountFound: "Your account was found. Your trading account details are shown below.",
    rateLimited: "Too many attempts. Please wait a moment and try again.",
  },
  signup: {
    title: "Sign Up",
    existingUser: "Existing User",
    newUser: "New User",
    lead: "Choose an option to continue.",
    existingHint: "Enter your account to check KYC status",
    newHint: "Fill in your details to register",
    back: "Back",
    close: "Close sign up",
    accountNumber: "Account Number",
    accountPlaceholder: "Enter your GODO account number",
    checkKyc: "Check KYC Status",
    checkingKyc: "Checking…",
    registerNow: "Register Now",
    submitting: "Submitting…",
    reviewAndContinue: "Review details",
    reviewTitle: "Review your details",
    reviewLead:
      "Please check that everything is correct. You can go back to make changes, or confirm to complete your registration.",
    editDetails: "Edit details",
    editDetailsLead: "Update your details below. Only changed fields are saved.",
    editDocumentsHint: "Upload new documents only if you need to replace them. Leave blank to keep the current files.",
    cancel: "Cancel",
    confirmRegister: "Confirm registration",
    reviewDocuments: "Documents",
    viewFile: "View",
    registerSuccessTitle: "Registration Received",
    registerSuccessLead:
      "Thank you. Your registration has been received and your documents are now under KYC review. Please save your account number below to check your status later.",
    alreadyExistsTitle: "Account already exists",
    alreadyExistsLead:
      "An account with this email or phone number already exists. We have recorded your interest in the competition. Account details are shown below.",
    registerDone: "Done",
    fullName: "Full Name (As per Passport)",
    fullNamePlaceholder: "Enter Full Name",
    nickname: "Nickname",
    nicknamePlaceholder: "e.g. AlexTrader",
    nicknameHint: "3–16 characters. Letters, numbers, underscore.",
    nicknameAvailable: "Nickname is available.",
    nicknameChecking: "Checking nickname…",
    nicknameSuggestions: "Try one of these:",
    saveNickname: "Save",
    savingNickname: "Saving…",
    editNickname: "Edit",
    detailsSaved: "Details saved.",
    detailsUnchanged: "No changes to save.",
    nicknameSaved: "Nickname saved.",
    nicknameBeforeKyc: "Choose your nickname first. Your KYC details will appear after you save it.",
    nicknameSavedWithEmail: "Nickname saved. Confirmation email sent.",
    existingContactFound:
      "We found an existing account for this email or phone. Please complete the missing fields below. Terms and beneficial owner confirmation are still required.",
    existingContactComplete:
      "We found an existing account for this email or phone. Please accept the terms and confirm beneficial ownership to continue.",
    checkingExisting: "Checking your details…",
    email: "Email Address",
    emailPlaceholder: "Enter Valid Email",
    phone: "Phone No",
    countryOfResidence: "Country Of Residence",
    nationality: "Nationality",
    dualNationality: "Dual Nationality",
    profession: "Profession",
    sourceOfFunds: "Source of Funds",
    proofOfIdentity: "Proof Of Identity",
    proofOfIdentityBack: "Proof Of Identity (Back Side)",
    proofOfAddress: "Proof Of Address",
    proofOfIdentityInfoLabel: "Proof Of Identity requirements",
    proofOfAddressInfoLabel: "Proof Of Address requirements",
    usCitizen: "Are you a US Citizen?",
    yes: "Yes",
    no: "No",
    hasCode: "Do you have Code?",
    codePlaceholder: "Enter code",
    chooseFile: "Choose a file",
    typeHere: "Type here...",
    search: "Search...",
    noResults: "No results found",
    specify: "Specify {label}",
    searchLabel: "Search {label}",
    countryCodes: "Country codes",
    select: "-- Select --",
    selectShort: "Select",
    notApplicable: "Not Applicable",
    approved: "Approved",
    fullNameShort: "Full Name",
    emailShort: "Email",
    phoneShort: "Phone",
    country: "Country",
    detailsProfile: "Profile",
    detailsLocation: "Location",
    detailsCompliance: "Compliance",
    beneficialOwnerShort: "Beneficial owner",
    termsAcceptedShort: "Terms accepted",
    kycStatus: "KYC Status",
    kycApproved:
      "Congratulations! Your KYC is approved. You are eligible to join the competition. Check your email for trading account details, or contact cs@godocm.com.",
    kycPending:
      "You are not eligible for the competition yet. Please contact admin at cs@godocm.com to complete KYC approval.",
    kycPendingContactEmail: "cs@godocm.com",
    kycNotFound: "No account found for this number.",
    forgotAccount: "Forgot your account number?",
    forgotAccountTitle: "Find your account",
    recoverLead:
      "Enter the email or phone number linked to your GODO trading account to view your account details.",
    recoverByEmail: "Email",
    recoverByPhone: "Phone",
    findAccount: "Find my account",
    recoverFound:
      "We found your account. Your trading account number and details are shown below.",
    recoverNotFound: "No account found for these details.",
    notApproved: "Under review",
    beneficialOwnerBefore:
      "I confirm that I am the beneficial owner and authorised trader of this account. If not, I have submitted the ",
    powerOfAttorney: "Power of Attorney",
    beneficialOwnerAfter: "",
    termsBefore: "By confirming registration, I confirm that: (1) I have read, understood and agree to the ",
    termsOfBusiness: "Terms of Business",
    termsAfter:
      ", (2) I give my consent for GODO to contact me at any reasonable time, and (3) my number is not registered on DNCR (Do Not Call Register).",
    competitionTermsBefore: "I have read and accept the ",
    competitionTermsLink: "Competition Terms & Conditions",
    competitionTermsAfter: ".",
    proofOfIdentityIntro:
      "Please provide at least ONE of the following documents that MUST have legal name, Not expired, date of birth, nationality, & registered ID number:",
    proofOfIdentityItems: [
      "Passport - For any Nationality",
      "Emirates ID, in case the client is UAE Resident",
      "Any other Government Issued ID which has these credentials",
    ],
    proofOfAddressIntro:
      "Please provide at least ONE of the following documents that MUST state current or permanent residential address as per Application form and have been issued within the last 3 calendar months",
    proofOfAddressItems: [
      "Utility Bills or statements from public utilities, including electricity, water, gas, or telephone line providers",
      "Lease / Tenancy Agreement (MUST be within the lease term)",
      "Local and national government-issued documents, including municipal tax records or similar",
      "Registered property purchase, lease or rental agreements",
      "Documents from supervised third-party financial institutions, such as bank statements or insurance policies, alike.",
      "Incase the client is sharing a bedspace or on a short term rent, may provide permenant residence document of his/her nationality.",
    ],
    professionOptions: {
      employed: "Employed",
      "self-employed": "Self-Employed",
      "business-owner": "Business Owner",
      student: "Student",
      management: "Management",
      unemployed: "Unemployed",
      other: "Other",
    },
    fundsOptions: {
      salary: "Salary",
      savings: "Savings",
      pension: "Pension",
      "profits-dividends": "Profits/Dividends",
      "sale-of-assets": "Sale of Assets",
      "crypto-investments": "Crypto Investments",
      "inheritance-gifts": "Inheritance & Gifts",
      other: "Other",
    },
    errors: {
      accountRequired: "Please enter your account number.",
      accountInvalid: "Enter a valid account number (4–20 letters or numbers).",
      fullNameRequired: "Please enter your full name as per passport.",
      fullNameShort: "Full name must be at least 2 characters.",
      fullNameLetters: "Full name can only contain letters, spaces, hyphens, and apostrophes.",
      emailRequired: "Please enter your email address.",
      emailInvalid: "Please enter a valid email address.",
      phoneRequired: "Please enter your phone number.",
      phoneInvalid: "Please enter a valid phone number.",
      countryRequired: "Please select your country of residence.",
      countryNotEligible: "This competition is only open in selected countries. Your current location is not eligible.",
      nationalityRequired: "Please select your nationality.",
      professionRequired: "Please select your profession.",
      professionOther: "Please specify your profession.",
      professionOtherLetters: "Profession can only contain letters and spaces.",
      fundsRequired: "Please select your source of funds.",
      fundsOther: "Please specify your source of funds.",
      fundsOtherLetters: "Source of funds can only contain letters and spaces.",
      identityRequired: "Please upload proof of identity.",
      identityBackRequired: "Please upload the back side of your identity document.",
      addressRequired: "Please upload proof of address.",
      usCitizenRequired: "Please select whether you are a US citizen.",
      beneficialOwner: "Please confirm you are the beneficial owner.",
      terms: "Please accept the terms to continue.",
      competitionTerms:
        "Please read and accept the competition terms and conditions to continue.",
      referral: "Please enter your code.",
      referralInvalid: "Referral code can only contain letters, numbers, hyphens, and underscores.",
      nicknameRequired: "Please choose a nickname.",
      nicknameLength: "Nickname must be 3–16 characters.",
      nicknameInvalid: "Start with a letter. Then use only letters, numbers, and underscore. No spaces.",
      nicknameReserved: "This nickname is reserved. Please choose another.",
      nicknameTaken: "This nickname is already taken. Please choose another.",
      emailTaken: "This email is already used by another account.",
      fileType: "Please upload a JPEG, PNG, WEBP, or PDF file only.",
      fileTooLarge: "Each file must be 10MB or smaller.",
      fileUploadFailed: "File upload failed. Please try again with a supported file.",
    },
  },
};

export default en;
